import { useEffect, useMemo, useRef } from "react";
import { useLocation, useMatches } from "react-router";

interface IRouteHandle {
  onLoaded?: (request: Request) => void;
}

export function useRouteHandler() {
  const matches = useMatches() as { handle?: IRouteHandle }[];
  const location = useLocation();
  const lastPathRef = useRef<string | null>(null);

  const currentMatch = matches.at(-1);
  const onLoaded = useMemo(
    () => currentMatch?.handle?.onLoaded,
    [currentMatch],
  );

  useEffect(() => {
    if (location.pathname !== lastPathRef.current && onLoaded) {
      lastPathRef.current = location.pathname;
      onLoaded(new Request(location.pathname));
    }
  }, [onLoaded, location.pathname]);
}
